/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Dismiss = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Dismiss 24">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M19.71 5.692a.991.991 0 1 0-1.402-1.402L12 10.598 5.692 4.29A.991.991 0 0 0 4.29 5.692L10.598 12 4.29 18.308a.991.991 0 0 0 1.402 1.402L12 13.402l6.308 6.308a.991.991 0 1 0 1.402-1.402L13.402 12l6.308-6.308Z"
        className="SVG"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const DismissIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'dismiss-icon'}
      icon={Dismiss}
      {...props}
      size={size}
    />
  );
};
